import { SkeletonLoader } from "../SkeletonLoader";

export const BannerPreviewSkeleton = () => (
  <div className="flex w-full flex-col gap-6 p-4">
    <div className="flex w-full flex-col gap-4">
      <SkeletonLoader height={144} variant="rounded" className="w-full" />
      <div className="flex items-center gap-2">
        <SkeletonLoader height={32} variant="rounded" className="flex-1" />
        <SkeletonLoader height={32} variant="rounded" className="flex-1" />
      </div>
    </div>

    <div className="flex w-full flex-col gap-4">
      <SkeletonLoader width={88} height={20} variant="rounded" />
      <SkeletonRow />
      <SkeletonRow />
      <SkeletonRow />
      <Divider />
      <SkeletonRow />
      <SkeletonRow />
      <Divider />
      <SkeletonRow />
    </div>
  </div>
);

const SkeletonRow = () => (
  <div className="flex w-full items-center justify-between">
    <SkeletonLoader width={88} height={20} variant="rounded" />
    <SkeletonLoader width={88} height={20} variant="rounded" />
  </div>
);

const Divider = () => (
  <div aria-hidden className="h-px w-full bg-stroke-primary" />
);
